export default function simulator() {
  var portionResult, productData
  var formValues = {}

  choosePet()
  choosePhase()
  fillWeight()
  fillPuppyNumber()
  fillCatOverWeightNumber()
  fillDogOverWeightNumber()
  chooseAgeAdultDog()
  chooseAgePuppyDog()
  chooseLactatingWeeksDog()
  chooseCastratedCat()
  chooseOverweightCat()
  chooseOverweightDog()

  function showPhase() {
    $('.fase').fadeIn()
  }

  function showWeight() {
    $('.weight-container').fadeIn()
  }

  function showInformationWeight() {
    $('.weight-container p').fadeIn()
  }

  function showAgeAdultDog() {
    $('.age-adult-dog').fadeIn()
  }

  function showAgePuppyDog() {
    $('.age-puppy').fadeIn()
  }

  function showProductResult() {
    $('section.simulator .result').fadeIn()
  }

  function showPuppyNumber() {
    $('section.simulator .puppy-number').fadeIn()
  }

  function showLactatingWeeks() {
    $('section.simulator .age-lactating-dog').fadeIn()
  }

  function showCastratedCat() {
    $('section.simulator .castrated-cat').css('display', 'grid')
  }

  function showOverweightDog() {
    $('section.simulator .overweight-adult-dog').css('display', 'grid')
  }

  function showDesiredWeightDog() {
    $('section.simulator .overweight-container.adult-dog').fadeIn()
  }

  function hideOverweightDog() {
    $('section.simulator .overweight-adult-dog').fadeOut()
  }

  function hideDesiredWeightDog() {
    $('section.simulator .overweight-container.adult-dog').fadeOut()
  }

  function showOverweightCat() {
    $('section.simulator .overweight-cat').css('display', 'grid')
  }

  function showDesiredWeight() {
    $('section.simulator .overweight-container.cat').fadeIn()
  }

  function hideCastratedCat() {
    $('section.simulator .castrated-cat').fadeOut()
  }

  function hideOverweightCat() {
    $('section.simulator .overweight-cat').fadeOut()
  }

  function hideDesiredWeight() {
    $('section.simulator .overweight-container.cat').fadeOut()
  }

  function hidePhase() {
    $('.fase').fadeOut()
  }

  function hideWeight() {
    $('.weight-container').fadeOut()
  }

  function hideInformationWeight() {
    $('.weight-container p').fadeOut()
  }

  function hideAgeAdultDog() {
    $('.age-adult-dog').fadeOut()
  }

  function hideAgePuppyDog() {
    $('.age-puppy').fadeOut()
  }

  function hideProductResult() {
    $('section.simulator .result').fadeOut()
  }

  function hidePuppyNumber() {
    $('section.simulator .puppy-number').fadeOut()
  }

  function hideLactatingWeeks() {
    $('section.simulator .age-lactating-dog').fadeOut()
  }

  function hideAllAges() {
    hideAgePuppyDog()
    hideAgeAdultDog()
  }

  function resetPhase() {
    $('.fase li').removeClass('active')
    $('input[name="phase"]').prop('checked', false)
  }

  function resetWeight() {
    $('input[name="weight"]').val('')
  }

  function resetPuppyNumber() {
    $('input[name="puppy-number"]').val('')
  }

  function resetLactatingWeeks() {
    $('.age-lactating-dog li').removeClass('active')
    $('.age-lactating-dog input[name="lactating-week"]').prop('checked', false)
  }

  function resetAgeAdultDog() {
    $('.age-adult-dog li').removeClass('active')
    $('.age-adult-dog input[name="age"]').prop('checked', false)
  }

  function resetAgePuppyDog() {
    $('.age-puppy li').removeClass('active')
    $('.age-puppy input[name="age"]').prop('checked', false)
  }

  function resetCastratedCat() {
    $('.castrated-cat li').removeClass('active')
    $('.castrated-cat input[name="castrated"]').prop('checked', false)
  }

  function resetOverweightCat() {
    $('.overweight-cat li').removeClass('active')
    $('.overweight-cat input[name="overweight"]').prop('checked', false)
  }

  function resetOverweightDog() {
    $('.overweight-adult-dog li').removeClass('active')
    $('.overweight-adult-dog input[name="overweight-dog"]').prop('checked', false)
  }

  function resetOverweightNumberCat() {
    $('input[name="overweight-number"]').val('')
  }

  function resetOverweightNumberDog() {
    $('input[name="overweight-dog-number"]').val('')
  }

  function resetAllAges() {
    resetAgeAdultDog()
    resetAgePuppyDog()
  }

  function choosePet() {
    $('input[name="pet"]').on('change', function() {
      $('.animal .row-line').removeClass('active')
      $(this)
        .parent('.row-line')
        .addClass('active')

      resetPhase()
      resetWeight()
      resetAllAges()
      resetPuppyNumber()
      resetLactatingWeeks()
      resetOverweightNumberCat()
      resetOverweightDog()
      resetOverweightCat()
      resetCastratedCat()
      resetOverweightNumberDog()

      hideWeight()
      hideInformationWeight()
      hideAllAges()
      hideProductResult()
      hidePuppyNumber()
      hideLactatingWeeks()
      hideDesiredWeight()
      hideOverweightCat()
      hideOverweightDog()
      hideCastratedCat()
      hideDesiredWeightDog()

      showPhase()
      getFormValues()
    })
  }

  function choosePhase() {
    $('input[name="phase"]').on('change', function() {
      $('.fase li').removeClass('active')
      $(this)
        .closest('li')
        .addClass('active')

      resetWeight()
      resetAllAges()
      resetPuppyNumber()
      resetLactatingWeeks()
      resetOverweightNumberCat()
      resetOverweightDog()
      resetOverweightCat()
      resetCastratedCat()
      resetOverweightNumberDog()

      hideAllAges()
      hideProductResult()
      hidePuppyNumber()
      hideLactatingWeeks()
      hideDesiredWeight()
      hideOverweightDog()
      hideOverweightCat()
      hideCastratedCat()
      hideDesiredWeightDog()

      showWeight()
      getFormValues()

      if (formValues.petValue == 'cao') {
        if (formValues.phaseValue == 'filhotes') {
          showInformationWeight()
        } else {
          hideInformationWeight()
        }
      }
    })
  }

  function fillWeight() {
    $('input[name="weight"]').on('input', function() {
      resetAllAges()
      resetPuppyNumber()
      resetLactatingWeeks()
      resetOverweightDog()
      resetOverweightNumberDog()

      hideLactatingWeeks()
      hideDesiredWeightDog()
      hideAgeAdultDog()

      getFormValues()
      let valor = $(this).val()
      if (valor > 0) {
        if (formValues.petValue == 'cao' && formValues.phaseValue == 'adultos') {
          hideProductResult()
          showOverweightDog()
        } else if (formValues.petValue == 'cao' && formValues.phaseValue == 'filhotes') {
          hideProductResult()
          showAgePuppyDog()

          if (valor < 12) {
            $('.age-puppy-4').hide()
          } else if (valor >= 12) {
            $('.age-puppy-4').show()
          }
        } else if (formValues.petValue == 'cao' && formValues.phaseValue == 'gestando') {
          formulas()
        } else if (formValues.petValue == 'cao' && formValues.phaseValue == 'lactando') {
          hideProductResult()
          showPuppyNumber()
        } else if (formValues.petValue == 'gato' && formValues.phaseValue == 'filhotes') {
          hideProductResult()
          showAgePuppyDog()
          $('.age-puppy-4').hide()
        } else if (formValues.petValue == 'gato' && formValues.phaseValue == 'adultos') {
          resetCastratedCat()
          resetOverweightCat()
          resetOverweightNumberCat()

          hideProductResult()
          hideOverweightCat()
          hideDesiredWeight()

          showCastratedCat()
        } else if (formValues.petValue == 'gato' && formValues.phaseValue == 'gestando') {
          formulas()
        } else if (formValues.petValue == 'gato' && formValues.phaseValue == 'lactando') {
          formulas()
        }
      } else {
        hideAllAges()
        hidePuppyNumber()

        resetCastratedCat()
        resetOverweightCat()
        resetOverweightNumberCat()

        hideProductResult()
        hideCastratedCat()
        hideOverweightCat()
        hideDesiredWeight()
      }
    })
  }

  function fillPuppyNumber() {
    $('input[name="puppy-number"]').on('input', function() {
      hideProductResult()

      resetLactatingWeeks()

      getFormValues()
      let valor = $(this).val()
      if (valor > 0) {
        showLactatingWeeks()
      } else {
        hideLactatingWeeks()
      }
    })
  }

  function fillCatOverWeightNumber() {
    $('input[name="overweight-number"]').on('input', function() {
      getFormValues()
      let valor = $(this).val()
      if (valor > 0) {
        formulas()
      } else {
        hideProductResult()
      }
    })
  }

  function fillDogOverWeightNumber() {
    $('input[name="overweight-dog-number"]').on('input', function() {
      getFormValues()
      let valor = $(this).val()
      if (valor > 0) {
        formulas()
      } else {
        hideProductResult()
      }
    })
  }

  function chooseAgeAdultDog() {
    $('.age-adult-dog input[name="age"]').on('change', function() {
      $('.age-adult-dog li').removeClass('active')
      $(this)
        .closest('li')
        .addClass('active')

      getFormValues()
      formulas()
    })
  }

  function chooseAgePuppyDog() {
    $('.age-puppy input[name="age"]').on('change', function() {
      $('.age-puppy li').removeClass('active')
      $(this)
        .closest('li')
        .addClass('active')

      getFormValues()
      formulas()
    })
  }

  function chooseLactatingWeeksDog() {
    $('input[name="lactating-week"]').on('change', function() {
      $('.age-lactating-dog li').removeClass('active')
      $(this)
        .closest('li')
        .addClass('active')

      getFormValues()
      formulas()
    })
  }

  function chooseCastratedCat() {
    $('input[name="castrated"]').on('change', function() {
      $('.castrated-cat li').removeClass('active')
      $(this)
        .closest('li')
        .addClass('active')

      resetOverweightCat()
      resetOverweightNumberCat()

      showOverweightCat()

      hideDesiredWeight()
      hideProductResult()

      getFormValues()
    })
  }

  function chooseOverweightCat() {
    $('.overweight-cat li input[name="overweight"]').on('change', function() {
      $('.overweight-cat li').removeClass('active')
      $(this)
        .closest('li')
        .addClass('active')

      resetOverweightNumberCat()
      hideProductResult()

      getFormValues()

      if (formValues.overweightValue == 'yes') {
        showDesiredWeight()
      } else {
        hideDesiredWeight()
      }

      formulas()
    })
  }

  function chooseOverweightDog() {
    $('.overweight-adult-dog li input[name="overweight-dog"]').on('change', function() {
      $('.overweight-adult-dog li').removeClass('active')
      $(this)
        .closest('li')
        .addClass('active')

      resetAllAges()
      resetOverweightNumberDog()

      hideAgeAdultDog()
      hideProductResult()

      getFormValues()

      if (formValues.overweightDogValue == 'yes') {
        showDesiredWeightDog()
      } else {
        hideDesiredWeightDog()
        showAgeAdultDog()

        if (formValues.weightValue < 12) {
          $('.age-adult-dog .age').html('7')
        } else if (formValues.weightValue >= 12) {
          $('.age-adult-dog .age').html('5')
        }
      }
    })
  }

  function getFormValues() {
    formValues['petValue'] = $('input[name="pet"]:checked')
      .map(function() {
        return $(this).val()
      })
      .get()
      .join(',')
    formValues['phaseValue'] = $('input[name="phase"]:checked')
      .map(function() {
        return $(this).val()
      })
      .get()
      .join(',')
    formValues['ageValue'] = $('input[name="age"]:checked')
      .map(function() {
        return $(this).val()
      })
      .get()
      .join(',')
    formValues['lactatingWeekValue'] = $('input[name="lactating-week"]:checked')
      .map(function() {
        return $(this).val()
      })
      .get()
      .join(',')
    formValues['castratedValue'] = $('input[name="castrated"]:checked')
      .map(function() {
        return $(this).val()
      })
      .get()
      .join(',')
    formValues['overweightValue'] = $('input[name="overweight"]:checked')
      .map(function() {
        return $(this).val()
      })
      .get()
      .join(',')
    formValues['overweightDogValue'] = $('input[name="overweight-dog"]:checked')
      .map(function() {
        return $(this).val()
      })
      .get()
      .join(',')
    formValues['weightValue'] = $('input[name="weight"').val()
    formValues['puppyValue'] = $('input[name="puppy-number"').val()
    formValues['overweightNumberValue'] = $('input[name="overweight-number"').val()
    formValues['overweightDogNumberValue'] = $('input[name="overweight-dog-number"').val()

    console.log(formValues)
  }

  const product = async id => fetch($('#simulator').data('action') + '?id=' + id).then(request => request.json())

  function formulas() {
    switch (formValues.petValue) {
      case 'cao':
        switch (formValues.phaseValue) {
          case 'adultos':
            switch (formValues.overweightDogValue) {
              case 'no':
                switch (formValues.ageValue) {
                  case 'adultos':
                    ;(async () => {
                      if (formValues.weightValue < 12) {
                        productData = await product(7)
                      } else if (formValues.weightValue >= 12) {
                        productData = await product(2)
                      }
                      console.log(productData)
                      portionResult = Math.round(((85 * Math.pow(formValues.weightValue, 0.75)) / productData.energy) * 1000)
                      showResult()
                      console.log('Resultado da fórmula: ' + portionResult)
                    })()
                    break
                  case 'senior':
                    ;(async () => {
                      if (formValues.weightValue < 12) {
                        productData = await product(9)
                      } else if (formValues.weightValue >= 12) {
                        productData = await product(8)
                      }
                      console.log(productData)
                      portionResult = Math.round(((85 * Math.pow(formValues.weightValue, 0.75)) / productData.energy) * 1000)
                      showResult()
                      console.log('Resultado da fórmula: ' + portionResult)
                    })()
                    break
                }
                break
              case 'yes':
                ;(async () => {
                  if (formValues.overweightDogNumberValue > 0) {
                    productData = await product(10)

                    var difference = formValues.weightValue - formValues.overweightDogNumberValue
                    var percent = 0.3 * formValues.overweightDogNumberValue

                    if (difference > percent) {
                      portionResult = Math.round(((72 * Math.pow(formValues.weightValue, 0.75)) / productData.energy) * 1000)
                    } else {
                      portionResult = Math.round(((85 * Math.pow(formValues.weightValue, 0.75)) / productData.energy) * 1000)
                    }

                    console.log(productData)

                    showResult()
                    console.log('Resultado da fórmula: ' + portionResult)
                  }
                })()
                break
            }
            break
          case 'filhotes':
            switch (formValues.ageValue) {
              case '1':
                ;(async () => {
                  if (formValues.weightValue < 12) {
                    productData = await product(5)
                    portionResult = Math.round(((160 * Math.pow(formValues.weightValue, 0.75)) / productData.energy) * 1000)
                  } else if (formValues.weightValue >= 12) {
                    productData = await product(6)
                    portionResult = Math.round(((150 * Math.pow(formValues.weightValue, 0.75)) / productData.energy) * 1000)
                  }

                  console.log(productData)

                  showResult()
                  console.log('Resultado da fórmula: ' + portionResult)
                })()
                break
              case '2':
                ;(async () => {
                  if (formValues.weightValue < 12) {
                    productData = await product(5)
                    portionResult = Math.round(((140 * Math.pow(formValues.weightValue, 0.75)) / productData.energy) * 1000)
                  } else if (formValues.weightValue >= 12) {
                    productData = await product(6)
                    portionResult = Math.round(((130 * Math.pow(formValues.weightValue, 0.75)) / productData.energy) * 1000)
                  }

                  console.log(productData)

                  showResult()
                  console.log('Resultado da fórmula: ' + portionResult)
                })()
                break
              case '3':
                ;(async () => {
                  if (formValues.weightValue < 12) {
                    productData = await product(5)
                    portionResult = Math.round(((120 * Math.pow(formValues.weightValue, 0.75)) / productData.energy) * 1000)
                  } else if (formValues.weightValue >= 12) {
                    productData = await product(6)
                    portionResult = Math.round(((110 * Math.pow(formValues.weightValue, 0.75)) / productData.energy) * 1000)
                  }

                  console.log(productData)

                  showResult()
                  console.log('Resultado da fórmula: ' + portionResult)
                })()
                break
              case '4':
                ;(async () => {
                  productData = await product(6)
                  portionResult = Math.round(((95 * Math.pow(formValues.weightValue, 0.75)) / productData.energy) * 1000)

                  console.log(productData)

                  showResult()
                  console.log('Resultado da fórmula: ' + portionResult)
                })()
                break
            }
            break
          case 'gestando':
            ;(async () => {
              if (formValues.weightValue < 12) {
                productData = await product(5)
              } else if (formValues.weightValue >= 12) {
                productData = await product(6)
              }

              portionResult = Math.round(((150 * Math.pow(formValues.weightValue, 0.75)) / productData.energy) * 1000)

              console.log(productData)

              showResult()
              console.log('Resultado da fórmula: ' + portionResult)
            })()
            break
          case 'lactando':
            switch (formValues.lactatingWeekValue) {
              case '1':
                ;(async () => {
                  if (formValues.weightValue < 12) {
                    productData = await product(5)
                  } else if (formValues.weightValue >= 12) {
                    productData = await product(6)
                  }

                  portionResult = Math.round(((140 * Math.pow(formValues.weightValue, 0.75) + 40 * formValues.weightValue * formValues.puppyValue * 0.75) / productData.energy) * 1000)

                  console.log(productData)

                  showResult()
                  console.log('Resultado da fórmula: ' + portionResult)
                })()
                break
              case '2':
                ;(async () => {
                  if (formValues.weightValue < 12) {
                    productData = await product(5)
                  } else if (formValues.weightValue >= 12) {
                    productData = await product(6)
                  }

                  portionResult = Math.round(((140 * Math.pow(formValues.weightValue, 0.75) + 40 * formValues.weightValue * formValues.puppyValue * 0.95) / productData.energy) * 1000)

                  console.log(productData)

                  showResult()
                  console.log('Resultado da fórmula: ' + portionResult)
                })()
                break
              case '3':
                ;(async () => {
                  if (formValues.weightValue < 12) {
                    productData = await product(5)
                  } else if (formValues.weightValue >= 12) {
                    productData = await product(6)
                  }

                  portionResult = Math.round(((140 * Math.pow(formValues.weightValue, 0.75) + 40 * formValues.weightValue * formValues.puppyValue * 1) / productData.energy) * 1000)

                  console.log(productData)

                  showResult()
                  console.log('Resultado da fórmula: ' + portionResult)
                })()
                break
            }
            break
        }
        break
      case 'gato':
        switch (formValues.phaseValue) {
          case 'filhotes':
            switch (formValues.ageValue) {
              case '1':
                ;(async () => {
                  productData = await product(11)
                  portionResult = Math.round(((200 * Math.pow(formValues.weightValue, 0.67)) / productData.energy) * 1000)

                  console.log(productData)

                  showResult()
                  console.log('Resultado da fórmula: ' + portionResult)
                })()
                break
              case '2':
                ;(async () => {
                  productData = await product(11)
                  portionResult = Math.round(((180 * Math.pow(formValues.weightValue, 0.67)) / productData.energy) * 1000)

                  console.log(productData)

                  showResult()
                  console.log('Resultado da fórmula: ' + portionResult)
                })()
                break
              case '3':
                ;(async () => {
                  productData = await product(11)
                  portionResult = Math.round(((160 * Math.pow(formValues.weightValue, 0.67)) / productData.energy) * 1000)

                  console.log(productData)

                  showResult()
                  console.log('Resultado da fórmula: ' + portionResult)
                })()
                break
            }
            break
          case 'adultos':
            switch (formValues.castratedValue) {
              case 'yes':
                switch (formValues.overweightValue) {
                  case 'no':
                    ;(async () => {
                      productData = await product(4)
                      portionResult = Math.round(((90 * Math.pow(formValues.weightValue, 0.67)) / productData.energy) * 1000)

                      console.log(productData)

                      showResult()
                      console.log('Resultado da fórmula: ' + portionResult)
                    })()
                    break
                  case 'yes':
                    ;(async () => {
                      if (formValues.overweightNumberValue > 0) {
                        productData = await product(4)
                        portionResult = Math.round(((90 * Math.pow(formValues.weightValue, 0.67)) / productData.energy) * 1000)

                        if (formValues.weightValue > formValues.overweightNumberValue) {
                          portionResult = Math.round(((80 * Math.pow(formValues.weightValue, 0.67)) / productData.energy) * 1000)
                        }

                        console.log(productData)

                        showResult()
                        console.log('Resultado da fórmula: ' + portionResult)
                      }
                    })()
                    break
                }
                break
              case 'no':
                switch (formValues.overweightValue) {
                  case 'no':
                    ;(async () => {
                      productData = await product(3)
                      portionResult = Math.round(((100 * Math.pow(formValues.weightValue, 0.67)) / productData.energy) * 1000)

                      console.log(productData)

                      showResult()
                      console.log('Resultado da fórmula: ' + portionResult)
                    })()
                    break
                  case 'yes':
                    ;(async () => {
                      if (formValues.overweightNumberValue > 0) {
                        productData = await product(1)
                        portionResult = Math.round(((100 * Math.pow(formValues.weightValue, 0.67)) / productData.energy) * 1000)

                        if (formValues.weightValue > formValues.overweightNumberValue) {
                          let porcent = ((formValues.weightValue - formValues.overweightNumberValue) / formValues.overweightNumberValue) * 100

                          if (porcent > 30) {
                            portionResult = Math.round(((85 * Math.pow(formValues.weightValue, 0.67)) / productData.energy) * 1000)
                          } else if (porcent <= 30) {
                            portionResult = Math.round(((90 * Math.pow(formValues.weightValue, 0.67)) / productData.energy) * 1000)
                          }
                        }

                        console.log(productData)

                        showResult()
                        console.log('Resultado da fórmula: ' + portionResult)
                      }
                    })()
                    break
                }
                break
            }
            break
          case 'gestando':
            ;(async () => {
              productData = await product(11)

              portionResult = Math.round(((150 * Math.pow(formValues.weightValue, 0.67)) / productData.energy) * 1000)

              console.log(productData)

              showResult()
              console.log('Resultado da fórmula: ' + portionResult)
            })()
            break
          case 'lactando':
            ;(async () => {
              productData = await product(11)

              portionResult = Math.round(((135 * Math.pow(formValues.weightValue, 0.67)) / productData.energy) * 1000)

              console.log(productData)

              showResult()
              console.log('Resultado da fórmula: ' + portionResult)
            })()
            break
        }
        break
    }
  }

  function scrollResult() {
    $('html, body').animate(
      {
        scrollTop: $('.result h1').offset().top - 110,
      },
      1000
    )
  }

  function showResult() {
    showProductResult()
    scrollResult()

    $('section.simulator .result-part').html(portionResult)
    $('section.simulator .result-image img').attr('src', productData.image)
    $('section.simulator .result-text-container h4').html(productData.title)
    $('section.simulator .result-link-button').attr('href', productData.slug)
    $('section.simulator .result-link-button').css('background-color', productData.hexadecimal)
    $('section.simulator .result-text-container h5').css('color', productData.hexadecimal)
    $('.result h1').css('color', productData.hexadecimal)
  }
}
